// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cj_freshway_wrap header h1[data-v-5b70097e]{color:#EC2619}\n", "",{"version":3,"sources":["webpack://./src/components/header/FreshwayHeader.vue"],"names":[],"mappings":"AACE,6CACE,aAAc","sourcesContent":["\n  .cj_freshway_wrap header h1 {\n    color: #EC2619;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
